window.Accordion = (accordionId) => {
  return {
	active_section: null,

	init() {
		// Turn this on to have the first section open by default
	//   let selector =
	// 	"#" + accordionId + " [id^='components-accordion-section-block'] > div";
	//   let first = document.querySelector(selector);
	//   this.active_section = first.id;
	},

	// scroll to top of active section
	// scrollToActiveSection() {
	//   setTimeout(() => {
	// 	let activeSection = document.getElementById(this.active_section);
	// 	activeSection.scrollIntoView({ behavior: "smooth", block: "start" });
	//   }, 250);
	// },
  };
};
